<template>
  <div class="download-btn-container">
    <img src="@/assets/download.svg"  class="img" />
    <span class="text" @click="download">Download Template</span>
    <loading-animation v-show="showLoader"></loading-animation>
  </div>
</template>

<script>
  export default {
    data(){
      return{
        showLoader: false,
      };
    },
    methods:{
      download(){
        this.showLoader = true;
        setTimeout(() => {
          this.$emit('downloadTemplate');
        }, 500)
        setTimeout(() => {
          this.showLoader = false;
        }, 1000);
      }
   },
  }
</script>

<style lang="scss" scoped>
@import "../../scss/_variables.scss";
.download-btn-container {
  display: flex;
  align-items: normal;
  .img {
    height: 18px;
    width: 16px;
    object-fit: contain;
  }
  .text {
    font-size: 14px;
    font-weight: 600;
    color: $color-secondary;
    margin-left: 8px;
    cursor: pointer;
  }
}
</style>
